// 주문 접수·시안 수정 단계에서 함께 안내하는 정책 값과 문구

// 시안 수정요청 무료 횟수 (서버 proofRouter의 FREE_PROOF_REVISIONS와 같아야 한다)
export const FREE_REVISION_LIMIT = 3;

export const REVISION_POLICY_LINES = [
  `시안은 정해진 수정요청 양식으로 요청하시면 최대 ${FREE_REVISION_LIMIT}회까지 무료로 수정해드립니다.`,
  `무료 횟수(${FREE_REVISION_LIMIT}회)를 모두 사용한 뒤의 추가 수정은 유료로 전환되며, 1회당 추가 비용이 결제금액에 합산됩니다.`,
  '단순 문의는 수정 횟수가 차감되지 않는 쪽지로 남겨주세요.',
];

export type ShippingMethod = 'SINGLE' | 'BULK';

export const SHIPPING_METHOD_OPTIONS: { value: ShippingMethod; label: string; desc: string }[] = [
  {
    value: 'SINGLE',
    label: '단건발송',
    desc: '주문 건마다 제작이 끝나는 대로 개별 발송합니다. 배송비는 발송 건마다 부과됩니다.',
  },
  {
    value: 'BULK',
    label: '일괄배송',
    desc: '진행 중인 여러 주문을 모아 한 번에 발송합니다. 배송비는 묶음 1회만 부과되며, 마지막 주문의 제작이 끝난 뒤 발송되어 수령이 늦어질 수 있습니다.',
  },
];

export const SHIPPING_METHOD_LABEL: Record<ShippingMethod, string> = {
  SINGLE: '단건발송',
  BULK: '일괄배송',
};

export type PaymentTerms = 'PREPAID' | 'POSTPAID';

export const PAYMENT_TERMS_LABEL: Record<PaymentTerms, string> = {
  PREPAID: '선결제 (최종 승인 후 결제)',
  POSTPAID: '후불결제',
};
